import React, { useContext, useEffect, useMemo } from 'react';
import { AuthContext } from "../../auth/Auth";
import { useParams } from "react-router-dom";
import { useProjectState, useProjectSchemas } from '../../global-state/useProjectSchemas';
import { ProjectSchemeManagement } from './../project_management/ProjectSchemeManagement';
import { Typography } from '@mui/material';
import { firebaseHelper, usePermissions } from 'ui';

export const ProjectSchemeShow = () => {
    const {id} = useParams();
    const {currentUser} = useContext(AuthContext);
    const { permissions, loading: permissionsLoading, hasProjectAccess } = usePermissions(currentUser?.uid, firebaseHelper.db);

    const {
        error,
        selectedProject,
        designFirms,
        teamMembers,
        associatedProjectsList,
        fetchProjectDataById,
        resetProjectData
    } = useProjectState();

    const { projectsLoaded, isProjectsLoading } = useProjectSchemas((state) => ({
        projectsLoaded: state.projectsLoaded,
        isProjectsLoading: state.isProjectsLoading
    }));

    // Calculate shared project IDs from permissions
    const sharedProjectIds = useMemo(() => {
        if (!permissions) return [];
        return [...new Set([
            ...(permissions.projectRead || []), 
            ...(permissions.projectWrite || [])
        ])];
    }, [permissions]);

    useEffect(() => {
        if (currentUser?.uid && permissions !== null && !permissionsLoading && !projectsLoaded && !isProjectsLoading) {
            useProjectSchemas.getState().getProjectSchemas(currentUser.uid, sharedProjectIds);
        }
    }, [currentUser?.uid, permissions, permissionsLoading, sharedProjectIds, projectsLoaded, isProjectsLoading]);

    useEffect(() => {
        if(permissionsLoading || isProjectsLoading) return;
        if (id !== selectedProject?.id) {
            resetProjectData();
        }
        if (!selectedProject && id && currentUser?.uid) {
          fetchProjectDataById(id, currentUser.uid, permissions);
        }
    }, [id, selectedProject, currentUser, permissions, permissionsLoading]);

    const isLoading = (!selectedProject && !error) && (permissionsLoading || isProjectsLoading);

    return (
        <>
            {isLoading && (
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        color: '#555',
                    }}
                >
                    Loading...
                </Typography>
            )}
            {selectedProject && !error && 
                <ProjectSchemeManagement 
                    selectedProject={selectedProject} 
                    designFirms={designFirms} 
                    teamMembers={teamMembers} 
                    associatedProjectsList={associatedProjectsList} 
                    permissions={permissions}
                    hasViewerAccess={(hasProjectAccess(selectedProject.id, 'read', selectedProject.owner) && !hasProjectAccess(selectedProject.id, 'write', selectedProject.owner))}
                />
            }
            {error && (
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        color: 'red',
                    }}
                >
                    {error}
                </Typography>
            )}
        </>
        
    );
};